<template>

    <ValidationObserver ref="form">
        <h2 class="profile__title">Performance Details</h2>
        <div class="row mb-5">

            <ValidationProvider
                class="col-md-6"
                name="Minutes in Material"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Minutes in Material</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="performanceDetails.minutes_in_material"
                    >
                    <FormError :error="errors[0]" name="Minutes in Material"></FormError>
                </div>

            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Number of shows/duration"
                v-slot="{ errors }"
                rules="required"
            >
                <div class="form-group mb-3">
                    <label for="" class="form-label">Available Shows</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="performanceDetails.available_shows"
                    >
                    <FormError :error="errors[0]" name="Number of shows/duration"></FormError>
                    <small class="color_primary">Number of shows and how many minutes each</small>
                </div>
            </ValidationProvider>
        </div>

        <div class="choose">
            <p class="form-question">Do you offer an Adult oriented show?</p>

            <ValidationProvider
                class="choose__inner"
                name="Offer an Adult oriented show"
                v-slot="{ errors }"
                rules="required"
            >
                <label class="choose__item">
                    <input
                        type="radio"
                        name="name-1"
                        :value="0"
                        v-model="performanceDetails.offer_adult"
                    >
                    <span>Yes</span>
                    <FormError :error="errors[0]" name="Offer an Adult oriented show"></FormError>
                </label>
                <label class="choose__item">
                    <input
                        type="radio"
                        name="name-1"
                        :value="1"
                        v-model="performanceDetails.offer_adult"
                    >
                    <span>No</span>
                </label>
            </ValidationProvider>
        </div>

        <div class="choose">
            <div class="row">
                <ValidationProvider
                    class="col-md-6"
                    name="Require a House Band"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <p class="form-question">Do you Require A House Band?</p>
                        <select
                            class="custom-select pl-4"
                            v-model="performanceDetails.require_house_band"
                        >
                            <option
                                v-for="option in houseBandRequirements"
                                :key="option.id"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                        <FormError :error="errors[0]" name="Require a House Band"></FormError>
                    </div>
                </ValidationProvider>
            </div>
        </div>

        <div class="choose">
            <p class="form-question">Do you use Animals in your show?</p>
            <ValidationProvider
                class="choose__inner"
                name="Animals in show"
                v-slot="{ errors }"
                rules="required"
            >
                <label class="choose__item">
                    <input
                        type="radio"
                        name="name-2"
                        v-model="performanceDetails.use_animals"
                        :value="1"
                    >
                    <span>Yes</span>
                    <FormError :error="errors[0]" name="Animals in show"></FormError>
                </label>
                <label class="choose__item">
                    <input
                        type="radio"
                        name="name-2"
                        v-model="performanceDetails.use_animals"
                        :value="0"
                    >
                    <span>No</span>
                </label>
            </ValidationProvider>

            <div class="form-group mt-4 mb-3">
                <label for="" class="form-label">What type of animals do you use?</label>
                <input
                    type="text"
                    class="form-control pl-4"
                    v-model="performanceDetails.animals_type"
                >
            </div>
        </div>

        <div class="choose">
            <p class="form-question">Do you use any Pyrotechnics in your show?</p>
            <ValidationProvider
                class="choose__inner"
                name="Pyrotechnics in show"
                v-slot="{ errors }"
                rules="required"
            >
                <label class="choose__item">
                    <input
                        type="radio"
                        name="name-3"
                        v-model="performanceDetails.use_pyrotechnics"
                        :value="1"
                    >
                    <span>Yes</span>
                    <FormError :error="errors[0]" name="Pyrotechnics in show"></FormError>
                </label>

                <label class="choose__item">
                    <input
                        type="radio"
                        name="name-3"
                        v-model="performanceDetails.use_pyrotechnics"
                        :value="0"
                    >
                    <span>No</span>
                </label>
            </ValidationProvider>
            <div class="form-group mt-4 mb-3">
                <label for="" class="form-label">What type of Pyrotechnics do you use?</label>
                <input
                    type="text"
                    class="form-control pl-4"
                    v-model="performanceDetails.pyrotechnics_type"
                >
            </div>
        </div>

        <div class="choose">
            <div class="row">
                <ValidationProvider
                    class="col-md-12"
                    name="Logistics Shipping Requirements"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <p class="form-question">Do you have any property and/or equipment that you carry on or that you requires logistics shipping for?</p>
                        <select
                            class="custom-select pl-4"
                            v-model="performanceDetails.equipment_shipping"
                        >
                            <option
                                v-for="option in logisticsShippingRequirements"
                                :key="option.id"
                            >
                                {{ option.name }}
                            </option>
                        </select>
                        <FormError :error="errors[0]"  name="Logistics Shipping Requirements"></FormError>
                    </div>
                </ValidationProvider>
            </div>
        </div>
    </ValidationObserver>

</template>

<script>
import FormError from "../Common/FormError.vue";
import {mapActions, mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import commonLists from "../../mixins/commonLists";

export default {
    name: "PerformanceDetails",
    components: {FormError},
    mixins: [commonLists],
    computed: {
        ...mapState(useArtistStore, {
            performanceDetails: 'performanceDetails'
        })
    },
    mounted() {
        this.dispatchState(this.performanceDetails)
    },
    watch: {
        performanceDetails: {
            handler(state) {
                this.dispatchState(state);
            },
            deep: true
        }
    }
}

</script>

<style scoped>

</style>
